import { createFileRoute } from '@tanstack/react-router';
import { validateTranslationsSearch } from '@/admin/copy/translations/search';
import { TranslationsScreen } from '@/admin/copy/translations/TranslationsScreen';

export const Route = createFileRoute('/admin/translations')({
  staticData: { minTier: 'ADMIN' },
  validateSearch: validateTranslationsSearch,
  component: TranslationsScreen,
});
